import { Col, Row } from 'antd';
import SummaryBenchmarkingCard from 'components/common/SummaryBenchmarkingCard';
import {
  TagBrandIcon,
  TotalApprovedPlacesIcon,
  TotalRevenueIcon,
  TotalYourCentresIcon,
} from 'components/common/SVGIcon';
import { summaryTitle } from 'containers/CompanyBenchmarking/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import {
  getNationalStates,
  getActivePrimaryChildCareServices,
} from 'redux/companyBenchmarking/selectors';
import { getFilterFromUrl } from 'utils/tools';
import { getBrandBenchmarkingSummary } from 'redux/brandBenchmarking/selectors';

const Summaries = ({ ownedCompanies, selectedBrandName }) => {
  const { pathname } = useLocation();
  const primaryChildCareServices = useSelector(
    getActivePrimaryChildCareServices,
  );
  const nationalStates = Object.values(useSelector(getNationalStates));

  const { search } = useLocation();
  const { filter } = getFilterFromUrl(search);
  const { userStatistic, totalStatistic } = useSelector(
    getBrandBenchmarkingSummary,
  );

  const summaries = [
    {
      yourTotalTitle: 'insight.summaries.yourBrands',
      yourTotalValue: userStatistic?.brand,
      allTotalTitle: 'insight.summaries.totalBrands',
      allTotalValue: totalStatistic?.brand,
      IconComponent: TagBrandIcon,
    },
    {
      yourTotalTitle: 'insight.summaries.yourCentres',
      yourTotalValue: userStatistic?.centres,
      allTotalTitle: 'insight.summaries.totalCentres',
      allTotalValue: totalStatistic?.centres,
      IconComponent: TotalYourCentresIcon,
      percentShareValue: userStatistic?.percentCentreShare,
      isNoUserCentre: !Number(userStatistic?.centres),
    },
    {
      yourTotalTitle: 'insight.summaries.yourApprovedPlaces',
      yourTotalValue: userStatistic?.approvedPlaces,
      allTotalTitle: 'insight.summaries.totalApproved',
      allTotalValue: totalStatistic?.approvedPlaces,
      IconComponent: TotalApprovedPlacesIcon,
      percentShareValue: userStatistic?.percentApprovedPlacesShare,
      isNoUserCentre: !Number(userStatistic?.centres),
    },
    {
      yourTotalTitle: 'insight.summaries.yourEstRevenue',
      yourTotalValue: userStatistic?.revenuePotential,
      allTotalTitle: 'insight.summaries.totalEstRevenue',
      allTotalValue: totalStatistic?.revenuePotential,
      IconComponent: TotalRevenueIcon,
      percentShareValue: userStatistic?.percentRevenuePotentialShare,
      isMoney: true,
      isNoUserCentre: !Number(userStatistic?.centres),
    },
  ];

  return (
    <div>
      <div className="mb-20 text-primary fw-bold text-16 mt-32">
        {summaryTitle(
          pathname,
          primaryChildCareServices,
          nationalStates,
          ownedCompanies,
          filter,
          selectedBrandName,
        )}
      </div>
      <Row gutter={[25, 25]} className="mb-20">
        {summaries.map((item, index) => (
          <Col xl={6} md={12} xs={24} key={Number(index)}>
            <SummaryBenchmarkingCard {...item} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

Summaries.propTypes = {
  resultFilter: PropTypes.object,
  ownedCompanies: PropTypes.array,
  selectedBrandName: PropTypes.string,
};

export default Summaries;
